import React, { Component } from 'react';
import { Typography, Grid, Table, TableHead, TableCell, TableRow, TableBody, Chip } from '@material-ui/core';
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css';
import { Button, FormControl, Card } from 'react-bootstrap';
import { PostData, GetData, DeleteData, PutData } from '../../api/service';
import Snack from '../Snackbar/Snack';
import FileUpload from '../AddNew/FileUpload';
import Edit from '@material-ui/icons/Edit'
import Delete from '@material-ui/icons/Delete'
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css


class CollegePopupNews extends Component {
    state = {
        id: '',
        edit: false,
        title: '',
        description: '',
        link: '',
        priority: 0,
        liveNow: '',
        upload_info: [],
        data: [],
        isDataLoaded: false,
        message: '',
        open: false,
        loadFile: true
    }

    handleChange = (name, value) => {
        this.setState({
            [name]: value
        })
    }

    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    __getPopupNewsData = () => {
        GetData(`/getpopupnews`)
            .then((resp) => {
                this.setState({
                    data: resp,
                    isDataLoaded: true
                })
            })
    }

    componentDidMount() {
        this.__getPopupNewsData();
    }


    onSubmit = (e) => {
        e.preventDefault();

        let d = {
            id: this.state.id,
            title: this.state.title,
            description: this.state.description,
            link: this.state.link,
            priority: this.state.priority,
            upload_info: this.state.upload_info,
            liveNow: this.state.liveNow,
        }

        if (this.state.edit) {
            PutData(`/admin/${this.state.id}/editpopupnews`, d)
                .then((resp) => {
                    this.setState({
                        message: resp,
                        open: true
                    }, () => this.__getPopupNewsData())
                    this.cancelEdit();
                })
        } else {
            PostData(`/admin/addpopupnews`, d)
                .then((resp) => {
                    this.setState({
                        message: resp,
                        open: true
                    }, () => this.__getPopupNewsData())
                    this.cancelEdit();
                })
        }


    }

    onDeleteClick = (el) => {
        confirmAlert({
            title: 'Confirm to delete',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: this.onDeleteConfirm.bind(this, el.id)
                },
                {
                    label: 'No'
                }
            ]
        })
    }

    onDeleteConfirm = (id) => {
        DeleteData(`/${this.props.apikey}/${id}/deletepopupnews`)
            .then((resp) => {
                this.setState({
                    message: resp,
                    open: true
                }, () => this.__getPopupNewsData())
            })
    }

    onEditClick = (el) => {
        this.setState({
            ...el,
            edit: true,
            loadFile: false
        }, () => {
            this.setState({
                loadFile: true
            })
        })
    }

    cancelEdit = () => {
        this.setState({
            id: '',
            title: '',
            description: '',
            link: '',
            priority: 0,
            liveNow: '',
            upload_info: [],
            edit: false,
            loadFile: false
        }, () => {
            this.setState({
                loadFile: true
            })
        })
    }


    render() {
        return (
            <div>

                {this.state.open ? (
                    <Snack
                        open={this.state.open}
                        message={this.state.message}
                        handleClose={() => {
                            this.setState({
                                open: false,
                                message: ''
                            })
                        }}
                    />
                ) : null}

                <form onSubmit={this.onSubmit}>
                    <Typography
                        variant="h6"
                        gutterBottom
                    >
                        Popup News
                    </Typography>

                    <Typography
                        variant="subtitle2"
                        gutterBottom
                    >
                        Every news marked as Live pops up when a visitor opens the website. Multiple news are shown one after another, higher priority first. A JPG / PNG picture is shown inside the popup and a PDF is shown as a preview with an open / download link.
                    </Typography>


                    <Card>

                        <Card.Body>


                            <Grid container spacing={2}>


                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <label>Title</label>
                                    <FormControl
                                        as="input"
                                        name="title"
                                        required
                                        onChange={this.onChange}
                                        value={this.state.title}
                                        placeholder="Title"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <label>Description</label>
                                    <ReactQuill
                                        placeholder="Type something here"
                                        value={this.state.description}
                                        onChange={this.handleChange.bind(this, 'description')}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <label>Link (optional)</label>
                                    <FormControl
                                        as="input"
                                        name="link"
                                        onChange={this.onChange}
                                        value={this.state.link}
                                        placeholder="https://"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                    <label>Priority (higher shows first)</label>
                                    <FormControl
                                        as="input"
                                        type="number"
                                        name="priority"
                                        onChange={this.onChange}
                                        value={this.state.priority}
                                        placeholder="0"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                    <label>Status (Live / Not Live)</label>
                                    <FormControl
                                        as="select"
                                        name="liveNow"
                                        required
                                        onChange={this.onChange}
                                        value={this.state.liveNow}
                                    >
                                        <option value="">Select Type</option>
                                        <option value="1">Live</option>
                                        <option value="0">Not Live</option>

                                    </FormControl>
                                </Grid>


                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <label>Upload Picture / PDF</label>
                                    {this.state.loadFile ? (<FileUpload
                                        dp={this.state.upload_info}
                                        type={`POPUP_NEWS`}
                                        setDp={this.handleChange.bind(this, 'upload_info')}
                                    />) : null}
                                </Grid>


                            </Grid>



                            {this.state.edit ? (
                                <div align="right">
                                    <Button
                                        size="sm"
                                        variant="danger"
                                        type="submit"
                                    >
                                        Update
                                    </Button>
                                    &nbsp;
                                    <Button
                                        size="sm"
                                        variant="danger"
                                        type="button"
                                        onClick={this.cancelEdit}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            ) : (<div align="right">
                                <Button
                                    size="sm"
                                    variant="info"
                                    type="submit"
                                >
                                    Submit
                                </Button>
                            </div>)}

                        </Card.Body>

                    </Card>

                    <br />


                    <Card>

                        <Card.Body>
                            {this.state.isDataLoaded ? (
                                <div>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>#</TableCell>
                                                <TableCell width="25%">Title</TableCell>
                                                <TableCell width="25%">Description</TableCell>
                                                <TableCell width="15%">Link</TableCell>
                                                <TableCell>Priority</TableCell>
                                                <TableCell>Upload Info</TableCell>
                                                <TableCell>Status</TableCell>

                                                <TableCell>Edit</TableCell>
                                                <TableCell>Delete</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Array.isArray(this.state.data) && this.state.data.map((el, index) =>

                                                <TableRow key={index}>
                                                    <TableCell>{index + 1}</TableCell>
                                                    <TableCell>{el.title}</TableCell>
                                                    <TableCell dangerouslySetInnerHTML={{ __html: el.description }}></TableCell>
                                                    <TableCell>
                                                        {el.link ? <a
                                                            href={el.link}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ wordBreak: 'break-all' }}
                                                        >
                                                            {el.link}
                                                        </a> : null}
                                                    </TableCell>
                                                    <TableCell>{el.priority}</TableCell>
                                                    <TableCell>
                                                        {Array.isArray(el.upload_info) && el.upload_info.map((el1, index1) =>
                                                            <Chip
                                                                key={index1}
                                                                label={el1.path}
                                                            />
                                                        )}
                                                    </TableCell>
                                                    <TableCell>{el.liveNow == 1 ? "Live" : "Not Live"}</TableCell>

                                                    <TableCell><Edit onClick={this.onEditClick.bind(this, el)} /></TableCell>
                                                    <TableCell><Delete onClick={this.onDeleteClick.bind(this, el)} /></TableCell>
                                                </TableRow>

                                            )}
                                        </TableBody>
                                    </Table>
                                </div>
                            ) : <Typography>
                                Loading . . .
                            </Typography>}
                        </Card.Body>

                    </Card>

                </form>
            </div>
        );
    }
}


export default CollegePopupNews;
